<template>
    <div v-if="!isWebSocketConnected">
        <div class="connection-tag">
            <span>Ni povezave s strežnikom. Ponovno povezovanje</span>
            <span class="dots"></span>
        </div>
    </div>
    <Main>
        <router-view />
    </Main>      
</template>

<script setup lang="ts">
    import Main from "@/app/views/app/main.vue";
    import router from "@app/router";
    import { useAppStore } from "@appstore/store";
    import { usePublicStore } from "@publicstore/store";
    import { commClient } from "fw4-library";
    import { useGeneralStore } from "@appstore/general-store";
    import { onMounted, provide, ref } from "vue";
    import { customSvgNameToComponent } from "@/app/assets/custom-svg";
    import { useFw4Store } from "fw4-library";

    const appStore = useAppStore();
    const publicStore = usePublicStore();
    const generalStore = useGeneralStore();

    publicStore.login.password = ""
    publicStore.login.loginError = ''; 

    const isWebSocketConnected = ref(false);

    const authenticationFailed = (): void => {
        console.log("error-auth");
        // router.push({name: "home"});
    };

    const socketConnected = (): void => {
        isWebSocketConnected.value = true;
    };

    const socketDisconnected = (): void => {
        isWebSocketConnected.value = false;
    };

    onMounted(async () => {
        commClient.OnWebSocketAuthenticationFailed.AddCallback(authenticationFailed);
        commClient.OnWebSocketConnected.AddCallback(socketConnected);
        commClient.OnWebSocketDisconnected.AddCallback(socketDisconnected);
        try {
            if (!commClient.WebSocketConnected) {
                await commClient.connectWebSockets();
            } else {
                isWebSocketConnected.value = true;
            }

            console.log("Commclients ws state: ", commClient.WebSocketConnected);
            console.log("WebSockets connected.");

            await generalStore.loadCountryLoad();
            await generalStore.postalCodeLoad();
            await generalStore.countryPhoneLoad();
            await appStore.LoadUserData();
        }
        catch (e) {
            console.error("WebSocket connection or initialization failed.", e);
        }
    });

    const { ShowReport } = useFw4Store();

    provide("showReport", ShowReport);
    provide("commClient", commClient);
    provide("generalStore", generalStore);
    provide("iconLibrary", customSvgNameToComponent);
</script>
